import { Box, CircularProgress, Grid } from '@material-ui/core';
import { SGSButton, SGSCard } from 'components';
import { useAppContext } from 'core/contexts';
import { affilieService } from 'core/services';
import { getContract, getWorkStoppageHistoryById } from 'core/services/workStoppage';
import SGSMuiStepperDotted from 'features/arretTravail/components/SGSMuiStepper';
import { Csp } from 'features/arretTravail/models/affilie';
import { CodeScenario, commonForm, FormName, getScenarioAtByCodes, ScenarioAt, storeCleaner } from 'features/arretTravail/models/scenarii';
import { RepriseOptions } from 'features/arretTravail/models/StopInformation/reprise';
import { WorkedHours, WorkStoppagePeriods } from 'features/arretTravail/models/StopInformation/workStoppage';
import { TypeAttestation } from 'features/arretTravail/models/typeAttestation';
import { TypeDeclaration } from 'features/arretTravail/models/typeChoix/index';
import { ReasonForWorkStop } from 'features/arretTravail/models/workStopReason';
import { getWorkStoppageCompagnie, populateSalaryBaseS3201WithInetrruption, postFicheParametrage, postWorkStoppage } from 'features/arretTravail/services/workStoppageService';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { useArretTravailFormContext } from '../../contexts/ArretTravailFormProvider';
import FormInterruptionActivityS6202 from './ActivityInterruptionS6202';
import FormDeclarationType from './declarationType'; //
import {
    FormAffilie,
    FormCertification,
    FormDeclarationReasons,
    FormInterim,
    FormSalaryBaseS3201,
    FormSalaryBaseS6202,
    FormSalaryInterruptionPeriodS3201,
    FormSalaryRappelS6202,
    FormSalaryReference,
    FormSubscriber,
    FormWorkStoppage,
} from './index';
import FormSubrogation from './Subrogation';

// TODO :: créer index pour y mettre tous les composants

type Props = {};

const FormFormulaireDeclaration: React.FC<Props> = () => {
    const { user } = useAppContext();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const { store, setStore, activeStep, setActiveStep, stepFailed, setFicheParametrage, setFileList } = useArretTravailFormContext();

    const scenario = getScenarioAtByCodes(store);

    const searchParams = new URLSearchParams(window.location.search);
    const codAffilie = searchParams.get('codAffilie');
    const codContrat = searchParams.get('codContrat');
    const id = searchParams.get('id');

    const isProduction = process.env.NODE_ENV === 'production';

    const formComponentsFiltered = formComponents.filter((component, index) => {
        // Display only 3 tabs during initialisation
        if (store?.typeAttestationCod == null && store?.reasonForWorkStopCod == null && store?.typeDeclarationCod == null) {
            return index < 3;
        }
        // Interim Subscriber
        if (component.codForm === FormName.Interim) {
            return store?.subscriber?.cc1 === '2378'; // TODO :: add to store cleaner
        }
        // Affiliate qualification interim
        if (component.codForm === FormName.SalaryReference && store?.affilie?.qualificationCod === Csp.TemporaryWorkers && !isProduction) {
            return false; // TODO :: add to store cleaner
        }

        if (!store?.typeDeclarationCod || store?.typeDeclarationCod === TypeDeclaration.Choice1) {
            return commonForm.includes(component.codForm as FormName);
        }

        return scenario.formsChoix2.concat(commonForm).includes(component.codForm);
    });

    useEffect(() => {
        const fetchAffilie = async () => {
            setLoading(true);
            try {
                const adhesion = await affilieService.getAffilieContract(codAffilie, codContrat);
                populateAdhesion(adhesion, setStore, user);
            } catch (error) {
                console.error('Error fetching affilie:', error);
            } finally {
                setLoading(false);
            }
        };
        if (codAffilie && codContrat) {
            fetchAffilie();
        }
        const fetchContract = async () => {
            setLoading(true);
            try {
                const adhesion = await getContract(codContrat);
                populateContract(adhesion, setStore, user);
            } catch (error) {
                console.error('Error fetching affilie:', error);
            } finally {
                setLoading(false);
            }
        };
        if (codContrat && !codAffilie) {
            fetchContract();
        }

        const fetchAT = async () => {
            setLoading(true);
            try {
                const AT = await getWorkStoppageHistoryById(id);
                const certification = {
                    fullname: user.nom + ' ' + user.prenom,
                    email: user.login, // TODO :: change for email
                    isCertified: false,
                };
                AT.certification = certification;
                console.log(AT);
                setStore(AT);
            } catch (error) {
                console.error('Error fetching affilie:', error);
            } finally {
                setLoading(false);
            }
        };
        if (id) fetchAT();
    }, [codAffilie, codContrat]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [activeStep]);

    const isLastStep = activeStep === formComponentsFiltered.length - 1;

    const sendFormToServer = async (formDatas) => {
        try {
            populateSalaryBaseS3201WithInetrruption(formDatas);
            // if (formDatas?.interruptionActivityS3201) {
            //     formDatas.interruptionActivityS3201.forEach((interruptionActivity) => {
            //         if (interruptionActivity.period) {
            //             const salaryBase = formDatas.salaryBaseS3201.find((entry) => entry.id === interruptionActivity.period);

            //             if (salaryBase) {
            //                 salaryBase.interruptionActivityS3201 = interruptionActivity;
            //             }
            //         }
            //     });

            //     delete formDatas.interruptionActivityS3201;
            // }

            await postWorkStoppage(formDatas);
            handleNext(null);
        } catch (error) {
            console.error('Error in sendFormToServer:', error);
        }
    };

    const parametrageSchema = Yup.object().shape({
        affiliate: Yup.object({
            noss: Yup.string().required('Affiliate NOSS is required'),
        }),
        contract: Yup.object({
            cod: Yup.string().required('Contract code is required'),
        }),
        subscriber: Yup.object({
            siret: Yup.string().required('Subscriber SIRET is required'),
        }),
        attestation: Yup.object({
            startDate: Yup.string().required('Attestation start date is required'),
            endDate: Yup.string().required('Attestation end date is required'),
            hireDate: Yup.string().required('Hire date is required'),
            type: Yup.string().required('Attestation type is required'),
            risk: Yup.string().required('Attestation risk is required'),
            reasonForWorkStop: Yup.string().required('Reason for work stoppage is required'),
            isHospitalized: Yup.string().required('Hospitalization status is required'),
        }),
    });

    const getFicheParametrage = async (store) => {
        try {
            setLoading(true);
            const parametrage = {
                affiliate: {
                    noss: store.affilie.SSNumber + store.affilie.SSkey,
                },
                contract: {
                    cod: store.contract.cod,
                },
                subscriber: {
                    siret: store.subscriber.siret,
                },
                attestation: {
                    startDate: moment(store.workStoppage.infos.start).format('YYYY-MM-DD'),
                    endDate:
                        store.workStoppage.infos.returnToWorkCod === RepriseOptions.Non
                            ? moment(store.workStoppage.infos.end).format('YYYY-MM-DD')
                            : moment(store.workStoppage.infos.returnToWorkDate).format('YYYY-MM-DD'),
                    hireDate: moment(store.affilie.hireDate).format('YYYY-MM-DD'),
                    type: '1',
                    risk: store.typeAttestationCod,
                    reasonForWorkStop: store.reasonForWorkStopCod,
                    isHospitalized: store.workStoppage.infos.isHospitalized ? '1' : '0',
                },
            };

            try {
                await parametrageSchema.validate(parametrage, { abortEarly: false });
            } catch (validationErrors) {
                validationErrors.inner.forEach((error) => {
                    console.error(error.message); // Log the validation error messages
                });
                setLoading(false);
                return; // Stop the function if validation fails
            }

            const fiche = await postFicheParametrage(parametrage);
            setLoading(false);
            console.log(fiche);
            return fiche;
        } catch (error) {
            console.error('Error fetching fiche parametrage:', error);
            setLoading(false);
        }
    };

    const initialisePieces = ({ fiche, scenario }: { fiche: any; scenario: ScenarioAt }) => {
        let tempPieceList = [];

        switch (scenario.code) {
            case TypeAttestation.Initial + CodeScenario.AT:
                if (store.affilie.qualificationCod === 'TRI') {
                    if (store.typeDeclarationCod === TypeDeclaration.Choice1) {
                        tempPieceList.push({ libelle: 'Attestation de salaire CPAM (CERFA)', code: 13 });
                    }

                    if (store.reasonForWorkStopCod !== ReasonForWorkStop.Paternite) {
                        tempPieceList.push({ libelle: 'Le contrat de mission en cours à la date de l’arrêt de travail', code: 36 }, { libelle: 'Le dernier bulletin de salaire', code: 38 });

                        if (['COVID19GE', 'MAL', 'AMRP', 'AMTN', 'MAT'].includes(store.reasonForWorkStopCod)) {
                            tempPieceList.push({ libelle: 'L’attestation pôle emploi', code: 37 });
                        }

                        if (['AT', 'MP'].includes(store.reasonForWorkStopCod)) {
                            tempPieceList.push({ libelle: 'La déclaration de l’accident (CERFA)', code: 39 });
                        }

                        if (['COVID19GE', 'MAL', 'AT', 'MP'].includes(store.reasonForWorkStopCod)) {
                            tempPieceList.push({ libelle: "Avis d'Arrêt (CERFA)", code: 4 });
                        }
                    }
                } else {
                    for (let i = 0; i < fiche.pieces.length; i++) {
                        const piece = fiche.pieces[i];

                        if (piece.code === 13 && store.typeDeclarationCod === TypeDeclaration.Choice2) {
                            tempPieceList.push({ libelle: piece.libelle, code: piece.code });
                        } else {
                            tempPieceList.push({ libelle: piece.libelle, code: piece.code });
                        }
                    }
                }
                break;
            default:
                break;
        }

        setFileList(tempPieceList);
    };

    const onSubmit = async (data: any) => {
        console.log(data);

        const currentForm = formComponentsFiltered[activeStep];
        const updatedStore = storeCleaner({ ...store, ...data });
        setStore(updatedStore);

        try {
            if (!isLastStep) {
                const promises = [];

                if (currentForm.codForm === FormName.WorkStoppage) {
                    const fichePromise = getFicheParametrage(updatedStore)
                        .then((fiche) => {
                            setFicheParametrage(fiche);
                            initialisePieces({ fiche, scenario });
                            // TODO: Ensure all necessary initializations are done here
                        })
                        .catch(() => {
                            // TODO :: improve error
                            setFicheParametrage(null);
                            initialisePieces({ fiche: null, scenario: null });
                        });
                    promises.push(fichePromise);

                    const compagniePromise = getWorkStoppageCompagnie({
                        idContract: updatedStore.contract.cod,
                        startDate: moment(updatedStore.workStoppage.infos.start).format('YYYY-MM-DD'),
                    })
                        .then((res) => {
                            if (res?.[0]) {
                                updatedStore.company = {
                                    cie: res[0].CIE,
                                    libelle: res[0].LIBELLE,
                                };
                            }
                        })
                        .catch(() => {
                            updatedStore.company = {
                                cie: null,
                                libelle: null,
                            };
                        });

                    promises.push(compagniePromise);
                }

                await Promise.all(promises);

                handleNext(updatedStore);
            } else {
                console.log('Submitting form...');
                console.log(updatedStore);
                await sendFormToServer(updatedStore);
            }
        } catch (error) {
            console.error('Error during form submission:', error);
        }
    };

    const handleBack = () => {
        if (activeStep > 0) {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };

    const handleNext = (form: any) => {
        console.log(form);
        setActiveStep((activeStep) => activeStep + 1);
    };

    const renderStepContent = (step: number) => {
        const currentForm = formComponentsFiltered[step];
        const CurrentFormComponent = currentForm?.component;

        return CurrentFormComponent ? (
            <CurrentFormComponent
                onSubmit={onSubmit}
                store={store}
                actions={
                    <Box className={'mt-5'}>
                        <Grid container justifyContent="center" alignItems="center" spacing={2}>
                            <Grid item xs={12} md={5} container justifyContent="flex-end">
                                <SGSButton id="btnBack" disabled={activeStep === 0 || loading} onClick={handleBack}>
                                    {t('global.back')}
                                </SGSButton>
                            </Grid>
                            <Grid item xs={12} md={2} container justifyContent="center">
                                {loading && <CircularProgress size={24} className="buttonProgress" />}
                            </Grid>
                            <Grid item xs={12} md={5} container justifyContent="flex-start">
                                <SGSButton id="btnNext" type="submit" disabled={loading}>
                                    {isLastStep ? t('workStopping.send') : t('global.next')}
                                </SGSButton>
                            </Grid>
                        </Grid>
                    </Box>
                }
            />
        ) : (
            <Box
                style={{
                    height: '500px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                Bravo ! Formulaire envoyé
            </Box>
        );
    };

    return (
        <>
            <SGSMuiStepperDotted steps={formComponentsFiltered.map((form) => t(`workStop.pages.${form.label}`))} activeStep={activeStep} setActiveStep={setActiveStep} stepFailed={stepFailed} />
            <SGSCard>
                <Box display="flex" flexDirection="column" alignItems="center">
                    {!loading ? renderStepContent(activeStep) : 'Chargement...'}
                </Box>
            </SGSCard>
        </>
    );
};

export default FormFormulaireDeclaration;

const formComponents: { label: string; component: React.FC<any>; codForm?: string }[] = [
    {
        label: 'motif',
        component: FormDeclarationReasons,
        codForm: FormName.DeclarationReason,
    },
    {
        label: 'declarationType',
        component: FormDeclarationType,
        codForm: FormName.TypeDeclaration,
    },
    {
        label: 'subscriber',
        component: FormSubscriber,
        codForm: FormName.Subscriber,
    },
    {
        label: 'victim',
        component: FormAffilie,
        codForm: FormName.Affilie,
    },
    {
        label: 'stopInformation',
        component: FormWorkStoppage,
        codForm: FormName.WorkStoppage,
    },
    {
        label: 'salaryBaseS6202',
        component: FormSalaryBaseS6202,
        codForm: FormName.SalaryBaseS6202,
    },
    {
        label: 'salaryRappel',
        component: FormSalaryRappelS6202,
        codForm: FormName.SalaryRappelS6202,
    },
    {
        label: 'salaryIncompletePeriod',
        component: FormInterruptionActivityS6202,
        codForm: FormName.SalaryIncompletePeriodS6202,
    },
    {
        label: 'salaryBase',
        component: FormSalaryBaseS3201,
        codForm: FormName.SalaryBaseS3201,
    },
    {
        label: 'salaryBaseRegulCotis',
        component: FormSalaryInterruptionPeriodS3201,
        codForm: FormName.SalaryInterruptionPeriodS3201,
    },
    {
        label: 'referenceSalaries',
        component: FormSalaryReference,
        codForm: FormName.SalaryReference,
    },
    {
        label: 'interim',
        component: FormInterim,
        codForm: FormName.Interim,
    },
    {
        label: 'subrogation',
        component: FormSubrogation,
        codForm: FormName.Subrogation,
    },

    {
        label: 'certification',
        component: FormCertification,
        codForm: FormName.Certification,
    },
];

const populateAdhesion = (adhesion, setStore, user) => {
    setStore({
        typeAttestationCod: TypeAttestation.Initial,
        reasonForWorkStopCod: ReasonForWorkStop.AccidentTravail,
        typeDeclarationCod: TypeDeclaration.Choice2,
        cerfa: '', // TODO :: add cerfa
        contract: {
            cod: adhesion.contract.cod,
            // libelle: adhesion.contract.libelle,
            // start: adhesion.contract.start,
            // end: adhesion.contract.end,
            // codCollege: adhesion.contract.codCollege,
            // college: adhesion.contract.college,
            // codCompany: adhesion.contract.codCompany,
            // compagny: adhesion.contract.company,
        },
        affilie: {
            cod: adhesion.affilie.cod,
            gender: adhesion.affilie.gender,
            lastname: adhesion.affilie.lastname,
            firstname: adhesion.affilie.firstname,
            birthDate: adhesion.affilie.birthDate,
            registrationNumber: adhesion.subscription.registrationNumber, /// --
            SSNumber: adhesion.affilie.numSecu.slice(0, -2),
            SSkey: adhesion.affilie.numSecu.slice(-2),
            regimeCod: '1', // TODO
            childNbr: adhesion.affilie.childNbr ?? 0,
            nationalityCod: 2, // TODO
            famillyStatusCod: 'm', // TODO
            email: adhesion.affilie.email, // TODO
            phone: adhesion.affilie.phone, // TODO
            address: adhesion.affilie.address,
            postalCode: adhesion.affilie.postalCode,
            city: adhesion.affilie.city,
            addressCplt: adhesion.affilie.addressCplt, // TODO :: ??,
            qualificationCod: 'SFP', // 'TRI', // TODO
            hireDate: adhesion.subscription.hireDate,
            statusCod: 'nc', // TODO :: rien à faire; on dispose pas de l'info
            coefHierarchi: adhesion.subscription.coefHierarchi,
            vrp: adhesion.subscription.vrp,
            tpa: false, // TODO ::
        },
        subscriber: {
            cod: adhesion.subscriber.cod, // TODO ::missing
            socialReason: adhesion.subscriber.socialReason,
            siret: adhesion.subscriber.siret,
            site: adhesion.subscriber.site,
            phone: adhesion.subscriber.phone,
            address: adhesion.subscriber.address,
            addressCplt: adhesion.subscriber.addressCplt,
            postalCode: adhesion.subscriber.postalCode,
            city: adhesion.subscriber.city,
            cc1: '2378', //adhesion.subscriber.cc1, // '2378', //
            idClient: adhesion.subscriber.idClient,
        },
        etablissement: {
            cod: adhesion.subscriber.cod, // TODO ::missing
            socialReason: adhesion.subscriber.socialReason,
            siret: adhesion.subscriber.siret,
            site: adhesion.subscriber.site,
            tel: adhesion.subscriber.tel,
            address: adhesion.subscriber.address,
            addressCplt: adhesion.subscriber.addressCplt,
            postalCode: adhesion.subscriber.postalCode,
            city: adhesion.subscriber.city,
            cc1: '2378', //adhesion.subscriber.cc1, // '2378', //
            idClient: adhesion.subscriber.idClient,
        },
        certification: {
            fullname: user.nom + ' ' + user.prenom,
            email: user.login, // TODO :: change for email
            isCertified: false,
        },
        // Diseable for testing
        workStoppage: {
            rights: {
                workedHours: WorkedHours.Minus200,
                period: WorkStoppagePeriods.sixMonths,
                contribution: '10.3',
                end: 'Sun Jun 30 2024 00:00:00 GMT+0200 (heure d’été d’Europe centrale)',
                start: 'Mon Jan 01 2024 00:00:00 GMT+0100 (heure normale d’Europe centrale)',
            },
            infos: {
                start: '2024-07-31T02:00:00.000Z',
                end: '2024-07-31T02:00:00.000Z',
                lastDayWorked: '2024-07-31T02:00:00.000Z',
                isHospitalized: 'false',
                returnToWorkCod: RepriseOptions.Non,
                situationAtStopDateCod: '4',
                hospitalizedDate: null,
                returnToWorkDate: null,
                hasOtherVictims: 'false',
                accidentDate: '2024-07-31T02:00:00.000Z',
            },
        },
        salaryBaseS3201: [
            {
                amount: '100',
                endDate: '2024-04-29T22:00:00.000Z',
                startDate: '2024-03-31T22:00:00.000Z',
                id: '3',
            },
            {
                amount: '200',
                endDate: '2024-05-30T22:00:00.000Z',
                startDate: '2024-04-30T22:00:00.000Z',
                id: '2',
            },
            {
                amount: '300',
                endDate: '2024-06-29T22:00:00.000Z',
                startDate: '2024-05-31T22:00:00.000Z',
                id: '1',
            },
        ],
        salaryBaseS6202: {
            salaries: [
                {
                    cotisation: '2.00',
                    amount: '10.00',
                    endDate: '2024-06-30T02:00:00.000Z',
                    startDate: '2024-06-01T02:00:00.000Z',
                    payrollDueDate: '2024-10-24T02:00:00.000Z',
                    id: '1',
                },
            ],
        },
        salaryRappelS6202: {
            salaries: [
                {
                    id: '1',
                    paymentDate: '2024-10-21T02:00:00.000Z',
                    startDate: '2024-10-22T02:00:00.000Z',
                    endDate: '2024-10-23T02:00:00.000Z',
                    amount: '30.00',
                    cotisation: '4.00',
                },
            ],
        },
        salaryRappelS3201: [
            {
                amount: '100.45',
                endDate: '2023-12-30T23:00:00.000Z',
                startDate: '2022-12-31T23:00:00.000Z',
                id: '1',
            },
        ],

        salaryReferences: {
            salaries: [
                {
                    id: '1',
                    startDate: '2024-07-01',
                    endDate: '2024-07-31',
                    salaryBrut: '10.00',
                    primesBrut: '20.00',
                    salaryNet: '30.00',
                    primesNet: '40.00',
                },
                {
                    id: '2',
                    startDate: '2024-06-01',
                    endDate: '2024-06-30',
                },
                {
                    id: '3',
                    startDate: '2024-05-01',
                    endDate: '2024-05-31',
                },
                {
                    id: '4',
                    startDate: '2024-04-01',
                    endDate: '2024-04-30',
                },
                {
                    id: '5',
                    startDate: '2024-03-01',
                    endDate: '2024-03-31',
                },
                {
                    id: '6',
                    startDate: '2024-02-01',
                    endDate: '2024-02-29',
                },
                {
                    id: '7',
                    startDate: '2024-01-01',
                    endDate: '2024-01-31',
                },
                {
                    id: '8',
                    startDate: '2023-12-01',
                    endDate: '2023-12-31',
                },
                {
                    id: '9',
                    startDate: '2023-11-01',
                    endDate: '2023-11-30',
                },
                {
                    id: '10',
                    startDate: '2023-10-01',
                    endDate: '2023-10-31',
                },
                {
                    id: '11',
                    startDate: '2023-09-01',
                    endDate: '2023-09-30',
                },
                {
                    id: '12',
                    startDate: '2023-08-01',
                    endDate: '2023-08-31',
                },
                {
                    id: '13',
                    startDate: '2023-07-01',
                    endDate: '2023-07-31',
                },
                {
                    id: '14',
                    startDate: '2023-06-01',
                    endDate: '2023-06-30',
                },
            ],
        },

        dateIndemnisationCcn: '2024-10-16T02:00:00.000Z',
        suspensions: [
            {
                endDate: '2024-10-16T02:00:00.000Z',
                startDate: '2024-10-16T02:00:00.000Z',
                id: '1',
            },
        ],
        interruptionActivityS6202: {
            interruptions: [
                {
                    id: '1',
                    startDate: '2024-10-24T02:00:00.000Z',
                    endDate: '2024-10-24T02:00:00.000Z',
                    reasonCod: 'AT',
                    amount: '10.00',
                    cotisationDeducted: '2.00',
                },
            ],
        },
        maintienInterruptionActivityS6202: 'NON',
        salaryMinimumS6202: {
            amount: '1000.00 ',
            contract: 'lbContract',
            contractDate: '2024-10-24T02:00:00.000Z',
        },
        interim: {
            pasRate: '50',
            payrollRate: '40',
            grossHourlyBonus: '30.00',
            hourlyRate: '20.00',
            weeklyDuration: '10',
            statut: 'CDII',
            mission: {},
            flexibilityPeriod: {
                isFlexible: 'false',
            },
            dateCdi: '2024-10-16T02:00:00.000Z',
            isTravelAccident: 'false',
        },
    });
};

const populateContract = (adhesion, setStore, user) => {
    setStore({
        typeAttestationCod: TypeAttestation.Initial,
        reasonForWorkStopCod: ReasonForWorkStop.AccidentTravail,
        typeDeclarationCod: TypeDeclaration.Choice2,
        cerfa: '', // TODO :: add cerfa
        contract: {
            cod: adhesion.contract.cod,
            // libelle: adhesion.contract.libelle,
            // start: adhesion.contract.start,
            // end: adhesion.contract.end,
            // codCollege: adhesion.contract.codCollege,
            // college: adhesion.contract.college,
            // codCompany: adhesion.contract.codCompany,
            // compagny: adhesion.contract.company,
        },
        subscriber: {
            cod: adhesion.subscriber.cod, // TODO ::missing
            socialReason: adhesion.subscriber.socialReason,
            siret: adhesion.subscriber.siret,
            site: adhesion.subscriber.site,
            tel: adhesion.subscriber.tel,
            address: adhesion.subscriber.address,
            addressCplt: adhesion.subscriber.addressCplt,
            postalCode: adhesion.subscriber.postalCode,
            city: adhesion.subscriber.city,
            cc1: adhesion.subscriber.cc1, // '2378', //
            idClient: adhesion.subscriber.idClient,
        },
        etablissement: {
            cod: adhesion.subscriber.cod, // TODO ::missing
            socialReason: adhesion.subscriber.socialReason,
            siret: adhesion.subscriber.siret,
            site: adhesion.subscriber.site,
            phone: adhesion.subscriber.phone,
            address: adhesion.subscriber.address,
            addressCplt: adhesion.subscriber.addressCplt,
            postalCode: adhesion.subscriber.postalCode,
            city: adhesion.subscriber.city,
            cc1: adhesion.subscriber.cc1, // '2378', //
            idClient: adhesion.subscriber.idClient,
        },
        certification: {
            fullname: user.nom + ' ' + user.prenom,
            email: user.login, // TODO :: change for email
            isCertified: false,
        },
        // Diseable for testing
        workStoppage: {
            rights: {
                workedHours: WorkedHours.Minus200,
                period: WorkStoppagePeriods.sixMonths,
                contribution: '10.3',
                end: 'Sun Jun 30 2024 00:00:00 GMT+0200 (heure d’été d’Europe centrale)',
                start: 'Mon Jan 01 2024 00:00:00 GMT+0100 (heure normale d’Europe centrale)',
            },
            infos: {
                start: '2024-07-31T02:00:00.000Z',
                end: '2024-07-31T02:00:00.000Z',
                lastDayWorked: '2024-07-31T02:00:00.000Z',
                isHospitalized: 'false',
                returnToWorkCod: RepriseOptions.Non,
                situationAtStopDateCod: '4',
                hospitalizedDate: null,
                returnToWorkDate: null,
                hasOtherVictims: 'false',
                accidentDate: '2024-07-31T02:00:00.000Z',
            },
        },
        salaryBaseS3201: [
            {
                amount: '100',
                endDate: '2024-04-29T22:00:00.000Z',
                startDate: '2024-03-31T22:00:00.000Z',
                id: '3',
            },
            {
                amount: '200',
                endDate: '2024-05-30T22:00:00.000Z',
                startDate: '2024-04-30T22:00:00.000Z',
                id: '2',
            },
            {
                amount: '300',
                endDate: '2024-06-29T22:00:00.000Z',
                startDate: '2024-05-31T22:00:00.000Z',
                id: '1',
            },
        ],
        salaryBaseS6202: {
            salaries: [
                {
                    cotisation: '2.00',
                    amount: '10.00',
                    endDate: '2024-06-30T02:00:00.000Z',
                    startDate: '2024-06-01T02:00:00.000Z',
                    payrollDueDate: '2024-10-24T02:00:00.000Z',
                    id: '1',
                },
            ],
        },
        salaryRappelS6202: {
            salaries: [
                {
                    id: '1',
                    paymentDate: '2024-10-21T02:00:00.000Z',
                    startDate: '2024-10-22T02:00:00.000Z',
                    endDate: '2024-10-23T02:00:00.000Z',
                    amount: '30.00',
                    cotisation: '4.00',
                },
            ],
        },
        salaryRappelS3201: [
            {
                amount: '100.45',
                endDate: '2023-12-30T23:00:00.000Z',
                startDate: '2022-12-31T23:00:00.000Z',
                id: '1',
            },
        ],

        salaryReferences: {
            salaries: [
                {
                    id: '1',
                    startDate: '2024-07-01',
                    endDate: '2024-07-31',
                    salaryBrut: '10.00',
                    primesBrut: '20.00',
                    salaryNet: '30.00',
                    primesNet: '40.00',
                },
                {
                    id: '2',
                    startDate: '2024-06-01',
                    endDate: '2024-06-30',
                },
                {
                    id: '3',
                    startDate: '2024-05-01',
                    endDate: '2024-05-31',
                },
                {
                    id: '4',
                    startDate: '2024-04-01',
                    endDate: '2024-04-30',
                },
                {
                    id: '5',
                    startDate: '2024-03-01',
                    endDate: '2024-03-31',
                },
                {
                    id: '6',
                    startDate: '2024-02-01',
                    endDate: '2024-02-29',
                },
                {
                    id: '7',
                    startDate: '2024-01-01',
                    endDate: '2024-01-31',
                },
                {
                    id: '8',
                    startDate: '2023-12-01',
                    endDate: '2023-12-31',
                },
                {
                    id: '9',
                    startDate: '2023-11-01',
                    endDate: '2023-11-30',
                },
                {
                    id: '10',
                    startDate: '2023-10-01',
                    endDate: '2023-10-31',
                },
                {
                    id: '11',
                    startDate: '2023-09-01',
                    endDate: '2023-09-30',
                },
                {
                    id: '12',
                    startDate: '2023-08-01',
                    endDate: '2023-08-31',
                },
                {
                    id: '13',
                    startDate: '2023-07-01',
                    endDate: '2023-07-31',
                },
                {
                    id: '14',
                    startDate: '2023-06-01',
                    endDate: '2023-06-30',
                },
            ],
        },

        dateIndemnisationCcn: '2024-10-16T02:00:00.000Z',
        suspensions: [
            {
                endDate: '2024-10-16T02:00:00.000Z',
                startDate: '2024-10-16T02:00:00.000Z',
                id: '1',
            },
        ],
        interruptionActivityS6202: {
            interruptions: [
                {
                    id: '1',
                    startDate: '2024-10-24T02:00:00.000Z',
                    endDate: '2024-10-24T02:00:00.000Z',
                    reasonCod: 'AT',
                    amount: '10.00',
                    cotisationDeducted: '2.00',
                },
            ],
        },
        maintienInterruptionActivityS6202: 'NON',
        salaryMinimumS6202: {
            amount: '1000.00 ',
            contract: 'lbContract',
            contractDate: '2024-10-24T02:00:00.000Z',
        },
        interim: {
            pasRate: '50',
            payrollRate: '40',
            grossHourlyBonus: '30.00',
            hourlyRate: '20.00',
            weeklyDuration: '10',
            statut: 'CDII',
            mission: {},
            flexibilityPeriod: {
                isFlexible: 'false',
            },
            dateCdi: '2024-10-16T02:00:00.000Z',
            isTravelAccident: 'false',
        },
    });
};
